import { runMigrations } from '@builder4/shared/migrations/runner';
import { CURRENT_STYLE_VERSION, migrations } from '@builder4/shared/migrations/style/registry';
import type { MigrationResult } from '@builder4/shared/migrations/types';
import type { MigratableJson } from './MigratableJson';

/**
 * Runs all necessary migrations to bring StyleJSON to the current schema version.
 *
 * @param data - The StyleJSON to migrate
 * @param targetVersion - Optional target version (defaults to CURRENT_SCHEMA_VERSION)
 * @returns Migration result with migrated JSON and metadata
 */
export function runStyleJsonMigrations<T extends MigratableJson = MigratableJson>(
  data: T,
  targetVersion: number = CURRENT_STYLE_VERSION,
): MigrationResult<T> {
  return runMigrations(data, migrations, targetVersion) as MigrationResult<T>;
}
